import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvModal from './AdvModal';
import { StyledButton } from './Button';

class DeleteDialogView extends Component {
  render() {
    const { isOpen, onConfirmDelete, onCloseDeleteDialog, title, hint, isProcessing } = this.props;
    return (
      <AdvModal
        className="popup generic-delete-dialog"
        isOpen={isOpen}
        onRequestClose={onCloseDeleteDialog}
        overlayClassName="closerdiv"
        shouldCloseOnOverlayClick={false}
      >
        <button type="button" className="generic-delete-dialog-x" onClick={onCloseDeleteDialog}>
          <i className="generic-delete-dialog-x-i fa fa-times" />
        </button>
        <div className="generic-delete-dialog-title">{title}</div>
        <div className="generic-delete-dialog-hint">{hint}</div>
        <div className="generic-delete-dialog-actions">
          <StyledButton.Secondary onClick={onCloseDeleteDialog}>Cancel</StyledButton.Secondary>
          <StyledButton.Danger
            style={{ marginLeft: '20px' }}
            onClick={onConfirmDelete}
            disabled={isProcessing}
            isLoading={isProcessing}
          >
            Delete
          </StyledButton.Danger>
        </div>
      </AdvModal>
    );
  }
}
DeleteDialogView.defaultProps = {
  isOpen: false,
  isProcessing: false,
};

DeleteDialogView.propTypes = {
  isOpen: PropTypes.bool,
  onConfirmDelete: PropTypes.func.isRequired,
  onCloseDeleteDialog: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  isProcessing: PropTypes.bool,
};
export default DeleteDialogView;
